import { Avatar, Typography } from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import Bell from "assets/icons/system/Bell"
import BellRing from "assets/icons/system/BellRing"
import BookClosed from "assets/icons/system/BookClosed"
import BookOpenNew from "assets/icons/system/BookOpen"
import HomeLine from "assets/icons/system/HomeLine"
import HomeSmile from "assets/icons/system/HomeSmile"
import clsx from "clsx"
import { useExcludeDivider } from "components/Navigation/hooks/useExcludeDivider"
import Link, { NavBackground } from "components/Navigation/Link"
import PageContainer from "components/PageContainer"
import { HOME_ONBOARDING_TARGETS } from "features/Home/HomeOnboarding/constants"
import { useNotifications } from "features/Notifications/hooks/useNotifications"
import NotificationsPopup from "features/Notifications/NotificationsPopup"
import { useSuraasaPlusContext } from "features/SuraasaPlus/context"
import { context } from "global/Context/context"
import { GraduationCap, Page } from "iconoir-react"
import { useContext, useEffect, useRef, useState } from "react"
import { Link as ReactRouterLink, useMatch } from "react-router-dom"
import routes from "routes"
import { breakpoints } from "utils/createBreakpoints"
import { buildUserName } from "utils/helpers"

import ProfileMenuButton from "./ProfileMenuButton"
import Sidebar from "./Sidebar"
import WithoutAuth from "./WithoutAuth"

type Props = {
  showSignInButton?: boolean
}
const SuraasaNameSvg = (
  <svg
    width="45"
    height="10"
    viewBox="0 0 45 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.9711 9.36103C40.5385 9.36103 40.1503 9.28398 39.8066 9.12989C39.4628 8.9758 39.1917 8.74762 38.9931 8.44536C38.7946 8.14014 38.6953 7.7638 38.6953 7.31634C38.6953 6.93407 38.765 6.61551 38.9042 6.36066C39.0465 6.10582 39.2391 5.90135 39.4821 5.74725C39.7251 5.59316 40.0007 5.47611 40.3088 5.3961C40.617 5.31609 40.9386 5.25979 41.2734 5.22719C41.6735 5.18571 41.9965 5.14718 42.2424 5.11162C42.4884 5.07606 42.6662 5.02124 42.7758 4.94716C42.8884 4.87307 42.9447 4.76195 42.9447 4.61378V4.58711C42.9447 4.27893 42.8514 4.04038 42.6647 3.87147C42.478 3.70256 42.2098 3.61811 41.8601 3.61811C41.4927 3.61811 41.2008 3.69812 40.9845 3.85814C40.7711 4.01815 40.6274 4.21373 40.5533 4.44487L38.9265 4.26707C39.0302 3.85221 39.2154 3.49957 39.4821 3.20917C39.7488 2.9158 40.0836 2.69355 40.4866 2.54242C40.8926 2.38833 41.3505 2.31128 41.8601 2.31128C42.2157 2.31128 42.561 2.35277 42.8958 2.43574C43.2336 2.51871 43.5374 2.65058 43.8071 2.83134C44.0797 3.01211 44.296 3.25213 44.456 3.55143C44.616 3.84776 44.696 4.21077 44.696 4.64045V9.22768H43.0247V8.28534H42.9714C42.8677 8.48685 42.7254 8.66909 42.5447 8.83208C42.3669 8.99506 42.1461 9.12397 41.8824 9.21879C41.6216 9.31362 41.3179 9.36103 40.9711 9.36103ZM41.4512 8.11643C41.7535 8.11643 42.0172 8.05717 42.2424 7.93863C42.4676 7.81714 42.6425 7.65564 42.7669 7.45413C42.8914 7.25262 42.9536 7.02889 42.9536 6.78294V6.0184C42.9003 6.05692 42.8173 6.09396 42.7047 6.12952C42.5951 6.16212 42.4706 6.19175 42.3313 6.21842C42.195 6.24213 42.0587 6.26436 41.9224 6.2851C41.7861 6.30584 41.6646 6.32362 41.5579 6.33844C41.3267 6.37104 41.1223 6.42438 40.9445 6.49846C40.7667 6.56958 40.6274 6.66885 40.5267 6.79627C40.4259 6.92073 40.3755 7.07927 40.3755 7.27189C40.3755 7.54748 40.4763 7.75787 40.6778 7.90308C40.8822 8.04531 41.1401 8.11643 41.4512 8.11643Z"
      fill="#121212"
    />
    <path
      d="M38.0985 4.27596L36.4983 4.40931C36.4628 4.26115 36.3946 4.12483 36.2939 4.00037C36.1961 3.87295 36.0642 3.7722 35.8983 3.69812C35.7323 3.62107 35.5323 3.58255 35.2982 3.58255C34.9841 3.58255 34.7203 3.64922 34.507 3.78257C34.2936 3.91592 34.1869 4.09224 34.1869 4.31152C34.1869 4.49229 34.2566 4.64194 34.3959 4.76047C34.5351 4.879 34.7707 4.97531 35.1026 5.04939L36.3028 5.29831C36.9576 5.43462 37.4451 5.65391 37.7652 5.95617C38.0882 6.25843 38.2497 6.65552 38.2497 7.14743C38.2497 7.586 38.1222 7.97123 37.8674 8.30312C37.6125 8.63502 37.2614 8.89431 36.8139 9.081C36.3665 9.26769 35.8523 9.36103 35.2715 9.36103C34.4033 9.36103 33.7069 9.17879 33.1824 8.8143C32.6608 8.44981 32.3526 7.94752 32.2578 7.30745L33.9736 7.18299C34.0388 7.47339 34.1825 7.69416 34.4047 7.84529C34.63 7.99642 34.9189 8.07198 35.2715 8.07198C35.6301 8.07198 35.9175 8.00086 36.1338 7.85862C36.3531 7.71342 36.4628 7.53266 36.4628 7.31634C36.4628 7.13261 36.3887 6.98148 36.2405 6.86295C36.0953 6.74145 35.8701 6.64959 35.5649 6.58736L34.3914 6.34733C33.7306 6.21102 33.2402 5.97988 32.9201 5.65391C32.603 5.32794 32.4445 4.91308 32.4445 4.40931C32.4445 3.97963 32.5616 3.60773 32.7957 3.29362C33.0327 2.97951 33.3631 2.738 33.7869 2.56909C34.2136 2.39722 34.7085 2.31128 35.2715 2.31128C36.1042 2.31128 36.7591 2.4876 37.2362 2.84023C37.7163 3.19287 38.0037 3.67145 38.0985 4.27596Z"
      fill="#121212"
    />
    <path
      d="M27.7934 9.36103C27.3608 9.36103 26.9726 9.28398 26.6288 9.12989C26.2851 8.9758 26.0139 8.74762 25.8154 8.44536C25.6169 8.14014 25.5176 7.7638 25.5176 7.31634C25.5176 6.93407 25.5872 6.61551 25.7265 6.36066C25.8687 6.10582 26.0613 5.90135 26.3043 5.74725C26.5473 5.59316 26.8229 5.47611 27.1311 5.3961C27.4393 5.31609 27.7608 5.25979 28.0957 5.22719C28.4957 5.18571 28.8187 5.14718 29.0647 5.11162C29.3106 5.07606 29.4884 5.02124 29.5981 4.94716C29.7107 4.87307 29.767 4.76195 29.767 4.61378V4.58711C29.767 4.27893 29.6736 4.04038 29.487 3.87147C29.3003 3.70256 29.0321 3.61811 28.6824 3.61811C28.315 3.61811 28.0231 3.69812 27.8067 3.85814C27.5934 4.01815 27.4497 4.21373 27.3756 4.44487L25.7487 4.26707C25.8524 3.85221 26.0376 3.49957 26.3043 3.20917C26.571 2.9158 26.9059 2.69355 27.3089 2.54242C27.7149 2.38833 28.1727 2.31128 28.6824 2.31128C29.038 2.31128 29.3832 2.35277 29.7181 2.43574C30.0559 2.51871 30.3597 2.65058 30.6293 2.83134C30.9019 3.01211 31.1183 3.25213 31.2783 3.55143C31.4383 3.84776 31.5183 4.21077 31.5183 4.64045V9.22768H29.847V8.28534H29.7937C29.6899 8.48685 29.5477 8.66909 29.3669 8.83208C29.1891 8.99506 28.9684 9.12397 28.7046 9.21879C28.4439 9.31362 28.1401 9.36103 27.7934 9.36103ZM28.2735 8.11643C28.5757 8.11643 28.8395 8.05717 29.0647 7.93863C29.2899 7.81714 29.4647 7.65564 29.5892 7.45413C29.7136 7.25262 29.7759 7.02889 29.7759 6.78294V6.0184C29.7225 6.05692 29.6396 6.09396 29.527 6.12952C29.4173 6.16212 29.2929 6.19175 29.1536 6.21842C29.0173 6.24213 28.881 6.26436 28.7446 6.2851C28.6083 6.30584 28.4868 6.32362 28.3802 6.33844C28.149 6.37104 27.9445 6.42438 27.7667 6.49846C27.5889 6.56958 27.4497 6.66885 27.3489 6.79627C27.2482 6.92073 27.1978 7.07927 27.1978 7.27189C27.1978 7.54748 27.2985 7.75787 27.5 7.90308C27.7045 8.04531 27.9623 8.11643 28.2735 8.11643Z"
      fill="#121212"
    />
    <path
      d="M21.0688 9.36103C20.6362 9.36103 20.248 9.28398 19.9042 9.12989C19.5605 8.9758 19.2893 8.74762 19.0908 8.44536C18.8922 8.14014 18.793 7.7638 18.793 7.31634C18.793 6.93407 18.8626 6.61551 19.0019 6.36066C19.1441 6.10582 19.3367 5.90135 19.5797 5.74725C19.8227 5.59316 20.0983 5.47611 20.4065 5.3961C20.7147 5.31609 21.0362 5.25979 21.3711 5.22719C21.7711 5.18571 22.0941 5.14718 22.3401 5.11162C22.586 5.07606 22.7638 5.02124 22.8735 4.94716C22.9861 4.87307 23.0424 4.76195 23.0424 4.61378V4.58711C23.0424 4.27893 22.949 4.04038 22.7623 3.87147C22.5757 3.70256 22.3075 3.61811 21.9578 3.61811C21.5903 3.61811 21.2985 3.69812 21.0821 3.85814C20.8688 4.01815 20.7251 4.21373 20.651 4.44487L19.0241 4.26707C19.1278 3.85221 19.313 3.49957 19.5797 3.20917C19.8464 2.9158 20.1813 2.69355 20.5843 2.54242C20.9903 2.38833 21.4481 2.31128 21.9578 2.31128C22.3134 2.31128 22.6586 2.35277 22.9935 2.43574C23.3313 2.51871 23.635 2.65058 23.9047 2.83134C24.1773 3.01211 24.3937 3.25213 24.5537 3.55143C24.7137 3.84776 24.7937 4.21077 24.7937 4.64045V9.22768H23.1224V8.28534H23.069C22.9653 8.48685 22.8231 8.66909 22.6423 8.83208C22.4645 8.99506 22.2438 9.12397 21.98 9.21879C21.7193 9.31362 21.4155 9.36103 21.0688 9.36103ZM21.5489 8.11643C21.8511 8.11643 22.1149 8.05717 22.3401 7.93863C22.5653 7.81714 22.7401 7.65564 22.8646 7.45413C22.989 7.25262 23.0513 7.02889 23.0513 6.78294V6.0184C22.9979 6.05692 22.915 6.09396 22.8024 6.12952C22.6927 6.16212 22.5682 6.19175 22.429 6.21842C22.2927 6.24213 22.1563 6.26436 22.02 6.2851C21.8837 6.30584 21.7622 6.32362 21.6555 6.33844C21.4244 6.37104 21.2199 6.42438 21.0421 6.49846C20.8643 6.56958 20.7251 6.66885 20.6243 6.79627C20.5236 6.92073 20.4732 7.07927 20.4732 7.27189C20.4732 7.54748 20.5739 7.75787 20.7754 7.90308C20.9799 8.04531 21.2377 8.11643 21.5489 8.11643Z"
      fill="#121212"
    />
    <path
      d="M14.6309 9.22778V2.40028H16.3288V3.56487H16.4C16.5244 3.15593 16.7363 2.8433 17.0356 2.62697C17.3349 2.41065 17.6772 2.30249 18.0624 2.30249C18.1543 2.30249 18.255 2.30694 18.3646 2.31582C18.4773 2.32472 18.5721 2.33805 18.6491 2.35583V3.93825C18.5721 3.91158 18.4565 3.88935 18.3024 3.87157C18.1513 3.85083 18.0091 3.84046 17.8757 3.84046C17.5912 3.84046 17.3364 3.90269 17.1112 4.02715C16.8859 4.14864 16.7082 4.31903 16.5778 4.53832C16.4474 4.75464 16.3822 5.00504 16.3822 5.28952V9.22778H14.6309Z"
      fill="#121212"
    />
    <path
      d="M12.1008 6.33865V2.40039H13.8521V9.22789H12.163V8.00108H12.0919C11.9378 8.39224 11.683 8.70931 11.3274 8.9523C10.9748 9.1953 10.5421 9.31679 10.0295 9.31679C9.57903 9.31679 9.18046 9.21456 8.83375 9.01009C8.49001 8.80562 8.22183 8.51225 8.02921 8.12998C7.83659 7.74771 7.7388 7.28691 7.73584 6.74759V2.40039H9.48717V6.45422C9.49013 6.87205 9.60422 7.20394 9.82943 7.4499C10.0546 7.69289 10.3525 7.81439 10.7229 7.81439C10.957 7.81439 11.1792 7.75957 11.3896 7.64992C11.6 7.53732 11.7719 7.37285 11.9052 7.15653C12.0386 6.93724 12.1038 6.66462 12.1008 6.33865Z"
      fill="#121212"
    />
    <path
      d="M5.25398 2.68477C5.21545 2.31139 5.05247 2.02099 4.76503 1.81356C4.47759 1.60612 4.09532 1.50241 3.61822 1.50241C3.28929 1.50241 3.00926 1.54982 2.77812 1.64465C2.54698 1.73947 2.37066 1.86986 2.24916 2.0358C2.12767 2.20175 2.06544 2.3914 2.06247 2.60476C2.05951 2.7796 2.09803 2.93221 2.17804 3.0626C2.26102 3.19298 2.37362 3.30411 2.51586 3.39597C2.6581 3.48783 2.81812 3.56636 2.99592 3.63156C3.17669 3.69675 3.36337 3.75157 3.55599 3.79602L4.39165 4.00049C4.76206 4.08346 5.11026 4.19607 5.43622 4.33831C5.76219 4.48055 6.04815 4.65835 6.2941 4.87171C6.54302 5.0821 6.7386 5.33399 6.88084 5.62736C7.02308 5.92072 7.0942 6.26151 7.0942 6.6497C7.0942 7.19495 6.95493 7.67057 6.67637 8.07654C6.40078 8.48252 6.00222 8.79811 5.48067 9.02333C4.96209 9.24854 4.33535 9.36115 3.60044 9.36115C2.88035 9.36115 2.25361 9.25002 1.72021 9.02777C1.18978 8.80552 0.77491 8.47808 0.475614 8.04543C0.179281 7.61278 0.0207433 7.08235 0 6.45412H1.74244C1.76614 6.76527 1.85949 7.02456 2.02247 7.232C2.18545 7.43647 2.40178 7.59056 2.67144 7.69428C2.9411 7.79799 3.24484 7.84985 3.58266 7.84985C3.92641 7.84985 4.2257 7.79947 4.48055 7.69872C4.73836 7.595 4.93838 7.45276 5.08062 7.272C5.22582 7.09124 5.29843 6.88084 5.29843 6.64081C5.29843 6.41856 5.23323 6.23484 5.10285 6.08963C4.97542 5.94147 4.79318 5.81701 4.55611 5.71626C4.31905 5.61254 4.03605 5.52068 3.70712 5.44067L2.69366 5.18286C1.93505 4.9932 1.33646 4.70132 0.897888 4.30719C0.459316 3.91011 0.240029 3.38115 0.240029 2.72033C0.240029 2.17508 0.386714 1.69947 0.680083 1.29349C0.976416 0.884553 1.38091 0.567477 1.89356 0.342264C2.40622 0.114088 2.98703 0 3.636 0C4.29682 0 4.87467 0.114088 5.36955 0.342264C5.86738 0.567477 6.25558 0.883071 6.53413 1.28905C6.81565 1.69206 6.96085 2.1573 6.96974 2.68477H5.25398Z"
      fill="#121212"
    />
  </svg>
)

const TopNavigation = ({ showSignInButton = true }: Props) => {
  const mdUp = useMediaQuery(breakpoints.up("md"))
  const { growthspaces, isNcte } = useContext(context)
  const [showNavDivider, setShowNavDivider] = useState(false)
  const currentGrowthSpaces = growthspaces.find(item => item.isCurrent)

  // const isNcte = true
  const handleScroll = () => {
    const scrollTop = window.scrollY

    const _getTopBarHeight = () => {
      const topBar = document.getElementById("top-heading-bar")
      if (topBar) {
        return topBar.clientHeight
      }
      return 0
    }

    const showNavDivider = scrollTop > _getTopBarHeight()

    setShowNavDivider(showNavDivider)
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    handleScroll()

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const { pageOverview } = useNotifications({
    useSearchParams: false,
    enableNotificationList: false,
  })
  const isAssignmentPage = useMatch(routes.assignment)

  const { data: notificationOverviewData } = pageOverview

  const [openSheet, setOpenSheet] = useState(false)

  const navContainerRef = useRef<HTMLDivElement>(null)

  const _omitDivider = useExcludeDivider()
  const omitDivider = showNavDivider ? false : _omitDivider

  const { authInfo, profile } = useContext(context)

  const hasNotification =
    notificationOverviewData && notificationOverviewData.all > 0

  const userName = authInfo ? buildUserName(authInfo.user) : ""

  const toggleSheet = () => {
    setOpenSheet(!openSheet)
  }
  const { isActive } = useSuraasaPlusContext()

  if (!authInfo) {
    return <WithoutAuth showSignInButton={showSignInButton} />
  }

  if (!mdUp) {
    return (
      <nav
        id="topNavbar"
        className={clsx(
          "top-0 z-navbar flex items-center justify-between bg-white px-2 py-1",
          { sticky: !isAssignmentPage },
          { "border-b border-onSurface-200": !omitDivider }
        )}
        style={{
          transition: "top 0.3s",
        }}
      >
        {isNcte ? (
          <ReactRouterLink to={routes.home}>
            <div className="flex items-center gap-1.25">
              <img
                src="https://assets.suraasa.com/logos/v2/mini.webp"
                alt="suraasa logo"
                height={33}
                width={31}
              />
              <div className="flex flex-col gap-0.25">
                {SuraasaNameSvg}
                <Typography className="max-w-[40ch] truncate align-bottom text-xs font-[450] leading-[100%] tracking-[-5%] text-[#939393]">
                  {currentGrowthSpaces?.organization?.name}
                </Typography>
              </div>
            </div>
          </ReactRouterLink>
        ) : (
          <ReactRouterLink to={routes.home}>
            <img
              src="https://assets.suraasa.com/logos/v2/mini.webp"
              alt="suraasa logo"
              height={35}
              width={35}
              className="block md:hidden"
            />
            <img
              src="https://assets.suraasa.com/logos/v2/full-dark.webp"
              alt="suraasa logo"
              width={120}
              className="hidden md:block"
            />
          </ReactRouterLink>
        )}

        <div className="flex flex-row items-center gap-1.5">
          <button
            onClick={toggleSheet}
            className={clsx("relative", HOME_ONBOARDING_TARGETS.profile)}
          >
            <Avatar
              className={clsx("size-4 !border border-onSurface-200", {
                "border-surface shadow-[0px_3.93px_9.82px_0px_rgba(0,0,0,0.05)]":
                  isActive,
              })}
              src={profile.picture}
              name={userName}
            />
          </button>
        </div>

        <Sidebar open={openSheet} handleClose={toggleSheet} />
      </nav>
    )
  }

  return (
    <nav
      id="topNavbar"
      className={clsx("top-0 z-navbar  bg-white py-0.25", {
        sticky: !isAssignmentPage,
        "border-b border-onSurface-200": !omitDivider,
      })}
    >
      <PageContainer>
        <div className="flex items-center justify-between">
          {isNcte ? (
            <ReactRouterLink to={routes.home}>
              <div className="flex items-center gap-1.25">
                <img
                  src="https://assets.suraasa.com/logos/v2/mini.webp"
                  alt="suraasa logo"
                  height={33}
                  width={31}
                />
                <div className="flex flex-col gap-0.25">
                  {SuraasaNameSvg}

                  <Typography className="max-w-[40ch] truncate align-bottom text-xs font-[450] leading-[100%] tracking-[-5%] text-[#939393]">
                    {currentGrowthSpaces?.organization?.name}
                  </Typography>
                </div>
              </div>
            </ReactRouterLink>
          ) : (
            <ReactRouterLink to={routes.home}>
              <img
                src="https://assets.suraasa.com/logos/v2/mini.webp"
                alt="suraasa logo"
                height={35}
                width={35}
                className="block md:hidden"
              />
              <img
                src="https://assets.suraasa.com/logos/v2/full-dark.webp"
                alt="suraasa logo"
                width={120}
                className="hidden md:block"
              />
            </ReactRouterLink>
          )}

          <div className="flex w-full justify-center">
            {mdUp ? (
              <div
                className="relative flex items-center justify-between gap-2"
                ref={navContainerRef}
              >
                <NavBackground containerRef={navContainerRef} />
                <Link
                  href={routes.home}
                  text="Home"
                  icon={<HomeLine />}
                  activeIcon={<HomeSmile />}
                />
                <Link
                  href={routes.learning}
                  text="Learning"
                  icon={<BookClosed />}
                  activeIcon={<BookOpenNew className="mt-0.25" />}
                />

                <Link
                  href={routes.masterclasses}
                  text="Masterclasses"
                  className="mb-[2.5px]"
                  icon={<GraduationCap height={22} width={22} />}
                  activeIcon={
                    <GraduationCap
                      height={22}
                      width={22}
                      className="mb-[2.5px]"
                    />
                  }
                />
                <Link
                  href={routes.cpat.dashboard}
                  text="CPAT"
                  icon={<Page fontSize={13} className="mb-0.5" />}
                  activeIcon={<Page fontSize={13} className="mb-0.5" />}
                />
              </div>
            ) : (
              <Link
                href="/home"
                text="Home"
                icon={<HomeLine />}
                activeIcon={<HomeSmile />}
              />
            )}
          </div>
          {mdUp && (
            <div className="flex items-center">
              <div className={clsx("ml-1", { relative: hasNotification })}>
                <Link
                  isMenu
                  arrow={false}
                  isNotification
                  hasNotification={hasNotification}
                  text="Notifications"
                  icon={<Bell />}
                  activeIcon={<BellRing />}
                  menuChildren={<NotificationsPopup />}
                />
                {hasNotification && (
                  <span className="absolute left-2.5 top-0 z-2 inline-flex justify-center rounded-full bg-critical-500 px-0.5 text-xs font-semibold text-common-white-500">
                    {notificationOverviewData.all}
                  </span>
                )}
              </div>

              <ProfileMenuButton
                coverStyle={profile.coverStyle}
                src={profile.picture}
                name={userName}
              />
            </div>
          )}
        </div>
      </PageContainer>
    </nav>
  )
}
export default TopNavigation
